import axios from 'axios';
export const signIn = async (signIn) => axios.post('/api/login_check', signIn).then((response) => response.data);
export const signUp = async (signUp) => {
    const { password, confirmPassword, acceptedTerms, ...rest } = signUp;
    return axios
        .post('/sign-up', { ...rest, plainPassword: password })
        .then((response) => response.data);
};
export const signOut = () => axios.post('/api/token/invalidate').then(() => null);
export const requestMagicLink = async (data) => axios.post('/auth/magic/requests', data).then((response) => response.data);
